import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

// @ts-ignore - dom-to-image non ha tipi corretti per ES6 import
import * as domtoimageModule from 'dom-to-image';
const domtoimage = domtoimageModule as any;

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  
  loaderVisible = false;
  imgArray: string[] = [];


  constructor(
    private toastController: ToastController
  ) {
    
  }

  showLoader() {
    this.loaderVisible = true;
  }

  hideLoader() {
    this.loaderVisible = false;
  }

  async showToast(msg: string, c: string, i?: string) {

    i = 'close-circle-outline';

   let toast;
   if(i)
   {
     toast = await this.toastController.create({
       message: msg,
       duration: 2000,
       // icon: i,
       color: c,
     });
   }
   else
   {
     toast = await this.toastController.create({
       message: msg,
       duration: 2000,
       color: c,
     });
   }
   toast.present();
 }

  roundPercentage(value: number, decimals: number): number {
    const asPercent = value * 100;
    const factor = Math.pow(10, decimals);
    return Math.round(asPercent * factor) / factor;
  }

  formatPercentage(value: number, decimals: number): string {
    const rounded = this.roundPercentage(value, decimals);
    // Usa toLocaleString con locale 'it-IT' per avere la virgola come separatore decimale
    return rounded.toLocaleString('it-IT', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  /**
   * Restituisce il path dell'icona per il tipo di possesso immobiliare
   */
  getImmobileIconPath(tipoId: number): string {
    switch (tipoId) {
      case 1: return 'assets/img/immobili/no-mutuo.svg'; // Proprietà senza mutuo
      case 2: return 'assets/img/immobili/mutuo.svg'; // Proprietà con mutuo
      case 3: return 'assets/img/immobili/affitto.svg'; // Sono in affitto
      case 4: return 'assets/img/immobili/uso-gratuito.svg'; // Sono in uso gratuito
      case 5: return 'assets/img/immobili/a-reddito.svg'; // Immobile a reddito
      case 6: return 'assets/img/immobili/immobile-gratuito.svg'; // Immobile ad uso gratuito
      default: return '';
    }
  }




  public domToImage = (element: HTMLElement): Promise<string> => {
    return new Promise((resolve, reject) => {
      domtoimage.toPng(element).then((dataUrl: string) => {
        let img = new Image();
        img.src = dataUrl;
        resolve(img.src);
      }).catch((err: any) => {
        reject(err);
      });
    });
  };

  public getHtml = (elements: HTMLElement[]): Promise<string[]> => {
    return new Promise((resolve, reject) => {
      const promiseArray: Promise<string>[] = [];

      // console.log(elements)
      const elementsArray = Array.from(elements);
      elementsArray.forEach((element: HTMLElement) => {
        promiseArray.push(this.domToImage(element));
      });

      Promise.all(promiseArray).then(
        (arrayB64: string[]) => {
          this.imgArray = arrayB64;
          resolve(this.imgArray);
        },
        (err: any) => {
          //this.loading.dismiss()
          console.log('loop err', err);
          reject(false);
        }
      );
    });
  };
}
